import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    standalone: false
})
export class AboutComponent {

  blur1: boolean = false;
  blur2: boolean = true;
  blur3: boolean = true;
  blur4: boolean = true;
  blur5: boolean = true;
  blur6: boolean = true;

  constructor(protected route: ActivatedRoute,
    protected router: Router
  ) {}

  showDate(div: number) {
    var divs = document.getElementsByClassName('aboutDate');
    for (var i = 0; i < divs.length; i++) {
      var divDate = 'date' + i;
      if (i == div) {
        divs[i].classList.add('active');
        var content = document.getElementsByClassName(divDate);
        content[0].classList.remove('hideDate');
      }
      else {
        divs[i].classList.remove('active');
        var content = document.getElementsByClassName(divDate);
        content[0].classList.add('hideDate');
      }
    }
  }
}
